import * as api from "../../api/apiConnector.js";
const chunkSize = 1024 * 1024 * 5;

const getAllFileEntries = async (dataTransferItemList) => {
    let fileEntries = [];
    let folderEntries = [];

    let queue = [];

    for (let i = 0; i < dataTransferItemList.length; i++) {
        queue.push(dataTransferItemList[i].webkitGetAsEntry());
    }

    while (queue.length > 0) {
        let entry = queue.shift();
        if (entry.isFile) {
            fileEntries.push(await readFilePromise(entry));
        } else if (entry.isDirectory) {
            folderEntries.push(entry);
            let reader = entry.createReader();
            queue.push(...await readAllDirectoryEntries(reader, entry));
        }
    }

    return { files: fileEntries, folders: folderEntries };
}

const readAllDirectoryEntries = async (directoryReader, folder) => {
    let entries = [];
    let readEntries = await readEntriesPromise(directoryReader);
    while (readEntries.length > 0) {
        entries.push(...readEntries);
        readEntries = await readEntriesPromise(directoryReader);
    }

    for(const e of entries) {
        e.folder = folder;
    }

    return entries;
}

const readEntriesPromise = async(directoryReader) => {
    try {
        return await new Promise((resolve, reject) => {
            directoryReader.readEntries(resolve, reject);
        });
    } catch (err) {
        console.log(err);
    }
}

const readFilePromise = async(fileEntry) => {    
        return await new Promise((resolve, reject) => {
            try {
                fileEntry.file(function (file){ 
                    file.folder = fileEntry.folder;
                    resolve(file)
                 });
            }
            catch (err) {
                reject(err);
            }            
        });    
}


const progressModal = () => {
    let progress_div = window.$(`<div class="col-xl-12" data-progress-id="progress-modal">
									<div class="card dz-card">
										<div class="card-header flex-wrap border-0">
											<div>
												<h4 class="card-title">File progress</h4>
												<p class="mb-0 subtitle">File <code></code></p>
											</div>											
										</div>
										<div class="tab-content">
											<div class="tab-pane fade active show" role="tabpanel" aria-labelledby="home-tab10">
												<div class="card-body pt-0">
													<h6><span data-progress-file-name="file-name"></span>
														<span class="pull-end">0%</span>
													</h6>
													<div class="progress">
														<div class="progress-bar bg-danger" style="width: 0%;" role="progressbar">
															<span class="sr-only">0% Complete</span>
														</div>
													</div>													
												</div>
											</div>
										</div>

									</div>
								</div>`);

    let div = window.$(`<div style="position: fixed; right: 10px; bottom: 10px; width: 450px; height: 200px;"></div>`);
    window.$("body").append(div);
    div.append(progress_div);

    let code = div.find("code");
    let h6 = div.find("h6");
    let h6_file_name = h6.find("span[data-progress-file-name]");
    let h6_file_name_progress = h6.find(".pull-end");
    let progress_bar = div.find(".progress-bar");
    let progress_bar_span = progress_bar.find("span");

    const setProgress = (fileName, fileNumber, totalFiles, value) => {
        code.text(`${fileNumber} of ${totalFiles}`);
        h6_file_name.text(`${fileName}`);
        h6_file_name_progress.text(`${value}%`);
        progress_bar.css("width", `${value}%`);
        progress_bar_span.text(`${value}%`);
    }

    const done = () => {
        div.find(".card-body").html("");
        div.find(".card-body").append(window.$("<h6/>").text("DONE"));
        setTimeout(() => {
            div.remove();
        }, 3000);
    }

    const errorMessage = (text) =>{
        div.find(".card-body").html("");
        div.find(".card-body").append(window.$("<h6/>").text(`${text}`));
        setTimeout(() => {
            div.remove();
        }, 6000);
    }


    return {
        setProgress,
        done,
        errorMessage
    }
}

const fileUpload = async (params) => {
    const { files, showProgress = true, parentId, onFileAdded, onFolderAdded, user } = params;

    if (files) {

        let _modal;

        if (showProgress) _modal = progressModal();

        for (var i = 0; i < files.length; i++) {
            const f = files[i];
            const { size, name, type, lastModifiedDate, __dms, folder } = f;

            if (showProgress) {
                _modal.setProgress(name, i + 1, files.length, 0);
            }

            var startResult = await api.sendMessage("dms/startUpload", {
                user,
                body: {
                    size, name, type, lastModifiedDate, parentId, file: __dms?.file, folder: folder?.fullPath
                }
            });

            if(!startResult.success)
            {
               _modal.errorMessage(startResult.message);
               return;
            }

            let start = 0;
            let end = chunkSize - 1;

            while (start < size) {
                const chunk = f.slice(start, end + 1);
                const chunk_array = await chunk.arrayBuffer();
                const chunk_data = Array.from(new Uint8Array(chunk_array));

                var chunkResult = await api.sendMessage("dms/chunkUpload", {
                    user,
                    body: {
                        uid: startResult.uid,
                        data: chunk_data,
                        last: end >= size
                    }
                });

                if (chunkResult.files && chunkResult.files.length > 0 && onFileAdded) {
                    onFileAdded(chunkResult.files);
                }

                if (chunkResult.folders && chunkResult.folders.length > 0 && onFolderAdded) {
                    onFolderAdded(chunkResult.folders);
                }

                console.log(`start: ${start} end: ${end}`);
                let _value = Math.trunc(start * 100 / size);

                if (showProgress) {
                    _modal.setProgress(name, i + 1, files.length, _value);
                }

                start += chunkSize;
                end += chunkSize;

                await new Promise(resolve => setTimeout(resolve, 500));
            }

            if (showProgress) {
                _modal.setProgress(name, i + 1, files.length, 100);
            }
        }

        if (showProgress) {
            _modal.done();
        }
    }
}

export { fileUpload, getAllFileEntries };